export default __webpack_public_path__ + "static/media/foldedPaper-double.e5f783b2.png";